import type { Hook } from 'phoenix_live_view';
import { pushPanelLoadEvent } from './push-panel-load';

export const loadPlayerStats: Hook = {
  mounted() {
    pushPanelLoadEvent(this, 'load-player-stats');
  },
  updated() {
    pushPanelLoadEvent(this, 'load-player-stats');
  },
};
